<template>
    <div class="boddy" ref="boddy">
<!-- <Header2 class="titlehed"></Header2> -->
        <Header :isScrolled="isScrolled"></Header>

        <!-- 测试开始 -->
        <img :src="imageUrlone" alt="" class="imgoneru">
        <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;background-color: white;height: 20vh;padding-top: 10vh;">
            <img style="margin-bottom: 4vh; height: 4vh; width: auto" :src="tenttwo.imageUrltwo" alt="">
            <div style="font-size: 2rem;">{{ isEnglish ? tenttwo.texttwoen:tenttwo.texttwo}}</div>
        </div>
       
        <div class="maintenance-section" v-for="(section, index) in sections" :key="index">
            <div class="section-title">{{ isEnglish ? section.titleen:section.title}}</div>
            <div class="section-content" v-for="(content, contentIndex) in (isEnglish ? section.contentsen : section.contents)" :key="contentIndex">
                {{ content }}
            </div>
            <!-- 添加分隔线 -->
            <!-- <div class="divider"></div> -->
            <!-- 只有当不是最后一个section时才显示分隔线 -->
            <div class="divider" v-if="index < sections.length - 1"></div>
        </div>


 <!-- 添加固定二维码 -->
 <div class="qr-code" :class="{ 'show': showQrCode }" >
    <img :src="showQrCodeimg" alt="二维码">
    <p style="font-size: 0.7rem;">微信扫码联系客服</p>
    <p style="font-size: 0.5rem;">WeChat customer service</p>
</div>
    
        <Bottom style="margin-top: 13vh;"></Bottom>
    </div>
</template>

<script>
    import Header from'@/view/public/heardpc.vue'
   
    import Bottom from "@/view/public/bottompc.vue";
    import { mapActions, mapState } from 'vuex';
    import axios from 'axios';
import apiUrls from '@/http/http'; // 假设 http.js 在 src/http 目录下
 
    export default {
        computed: {
            // 从 Vuex 的 state 中获取 isEnglish 数据
            ...mapState(['isEnglish']), // 这里读取 state 中的 isEnglish 状态
              // Vuex 的 actions 映射到 methods
              ...mapActions(['changeLanguage']),

           // 使用 computed 属性来拼接 URL
                    uploadAction() {
                    return `${apiUrls.baseUrl}/website/dev-api/common/upload`;
                    },
             
        },
        components:{
            // Header2,
            Header,
            // Bottom2,
            Bottom
        },
        data() {
            return { 
                showQrCode: false,
                showQrCodeimg: require('../../assets/a4885edcff1d9e445b19ec692f1055f.jpg'),
                sections: [
                    {
                        title: 'Q：铝镁合金商旅箱需要托运吗？可以直接登机吗？',
                        titleen: 'Q: Does an aluminum-magnesium alloy business travel case need to be checked in? Can it be carried onto the plane directly?',
                        contents: [
                            'A：18寸和20寸的商旅箱可直接登机，无需托运。但是不同航空公司对尺寸有不同的要求，请您在选择班次时需要了解一下航空公司的具体规定。',
                            
                        ],
                        contentsen: [
                            'A: 18-inch and 20-inch business travel cases can be carried onto the plane directly without checking in. However, different airlines have different requirements for size, so please check the specific regulations of the airline when choosing your flight.'
                        ]
                    },
                    {
                        title: 'Q：铝镁合金商旅箱该怎么养护？如何防刮蹭？',
                        titleen: 'Q: How should I maintain an aluminum-magnesium alloy business travel case? How can I prevent scratches?',
       
                        contents: [
                           ' • 避免尖锐的物品刮划箱体表面,使用时尽量用箱套保护。',
                          ' • 长时间使用后可在轮子轴心滴少许润滑油。',
                           ' • 箱包在半年不使用的情况下,请人工滚动轮子,因产品使用的轮子为环保材料,如长期不用会有风化现象。',
                          '  • 商旅箱尽量立放，不要平放且不要长时间压放重物,以免造成变形。',
                           '• 盛装较多物品后箱子要平放开合，且开箱时注意面板是否变形。',
                          ' • 清洁时用中性洗洁剂擦试，勿用肥皂、洗衣粉或其它强酸，强碱的化学物品。',
                        ],
        contentsen: [
            '• Avoid sharp objects scratching the surface of the case, and try to use a case cover for protection when using it.',
            '• After prolonged use, apply a small amount of lubricating oil to the wheel axle.',
            '• If the case is not used for half a year, please manually roll the wheels, as the wheels used in the product are made of environmentally friendly materials and may weather if not used for a long time.',
            '• Try to stand the business travel case upright, do not lay it flat, and do not place heavy objects on it for a long time to avoid deformation.',
            '• When the case is filled with many items, open and close it flat, and pay attention to whether the panel is deformed when opening the case.',
            '• Use a neutral detergent for cleaning, and do not use soap, washing powder, or other strong acid or strong alkali chemical substances.'
        ]
                    },
                    {
                        title: 'Q：忘记密码该如何处理？',
                       titleen: 'Q: What should I do if I forget my password?',
                        contents: [
                           ' A：请您立即拨打谱祺官方售后客服（电话:020-3939 0239,工作日拨打）',
                           '或发送邮件至coop@puki.vip或直接扫码二维码联系专门的售后人员为您解决问题。'
                          
                        ],
                        contentsen: [
                           ' A: Please call the official after-sales customer service of Puqi immediately (Tel: 020-3939 0239, call on weekdays)',
                            'Or send an email to coop@puki.vip or scan the QR code to contact the dedicated after-sales staff to solve the problem for you. '
                        ]
                    },
                    {
                        title: 'Q：我的商旅箱被暴力托运损坏了，怎么办？',
                        contents: [
                           ' A：若遇到机场托运导致商旅箱损坏的，请务必保留登机牌/行李托运小票第一时间到机场行李查询处，可直接办理行李破损理赔业务。（温馨提示：离开机场后，无法进行理赔）。'
                          
                        ],
                        titleen: 'Q: What should I do if my business travel case is damaged during violent checked baggage handling?',
                        contentsen: ['A: If your business travel case is damaged during airport checked baggage handling, please be sure to keep your boarding pass/baggage check receipt and go to the airport baggage inquiry office immediately to directly handle the baggage damage compensation business. (Friendly reminder: Compensation cannot be processed after leaving the airport).']
                    },
                    {
                        title: 'Q：密码锁上的钥匙孔应该如何使用?',
                        contents: [
                           ' A：商旅箱配置的锁都是TSA海关锁，不配备钥匙。钥匙孔是为海关提供的。在部分地区的海关，登机过安检时，需要检查箱包内物品，海关会有专门钥匙打开TSA密码锁，否则海关可能会选择暴力开箱破坏您箱子上的锁以完成检查。'
                          
                        ],
                        titleen: 'Q: How should the keyhole on the combination lock be used?',
                        contentsen: [
                            'A: The locks equipped with business travel cases are all TSA customs locks and are not equipped with keys. The keyhole is provided for customs. In some regions, when boarding and passing through security, customs needs to inspect the items in the luggage. Customs will have a special key to open the TSA combination lock, otherwise customs may choose to forcibly open your case is lock to complete the inspection.'
                        ]
                    },
                    {
                        title: 'Q：产品的编码在哪里？有何作用？',
                        contents: [
                           ' A：编码在箱体的下方，每一个铝镁合金商旅箱都有独立的编码，是为了可以溯源产品的生产年份、生产序列号等信息，更好地为您提供售后服务。'
                        ],
                        titleen: 'Q: Where is the product code? What is its purpose?',
                        contentsen: [
                            'A: The code is located at the bottom of the case. Each aluminum-magnesium alloy business travel case has a unique code, which is used to trace the production year, production serial number, and other information of the product, so as to provide better after-sales service for you.'
                        ]
                    },
                ],
              

                tenttwo:{
                    imageUrltwo: require('../../assets/logotuteng.png'),
                    texttwo:'常见问题',
                    texttwoen:'Foire aux questions',
                },
               
                tenttfour:{
                    titleone:'箱包的保养',
                    titleoneen:'Maintenance of luggage',
                   content:[
                    '避免尖锐的物品刮划箱体表面,使用是尽量用箱套保护。',
                    '长时间使用后可在轮子轴心滴少许润滑油。',
                    '箱包在半年不使用的情况下,请人工滚动轮子,因产品使用的轮子为环保材料,如长期不用会有风化现象。',
                    '购买商品后超过7天退、换货期限。',
                    '箱包不用时请用塑胶袋或箱套套上。',
                    '箱包尽量立放，不要平放且不要长时间压放重物,以免造成永久变形。',
                    '盛装较多物品后箱子要平放开合，且开箱时注意面板是否变型。',
                    '清洁时用中性洗洁剂擦试，勿用肥皂、洗衣粉或其它强酸，强碱的化学物品。'
                   ],
                   contenten:[
                    'Avoid sharp objects from scratching the surface of the box, and try to protect it with a case cover as much as possible.',
                    'After long-term use, a little lubricating oil can be dropped on the shaft of the wheel.',
                    'If the luggage is not used for half a year, please roll the wheels manually, because the wheels used in the product are environmentally friendly materials, and there will be weathering if not used for a long time.',
                    'After the purchase of the product, the return and exchange period exceeds 7 days.',
                    'When the bag is not in use, please use a plastic bag or box sleeve to cover it.',
                    'Bags should be placed vertically as much as possible, not flat and not pressed for a long time, so as not to cause permanent deformation.',
                    'After containing more items, the box should be closed flat, and pay attention to whether the panel is deformed when unpacking.',
                    'When cleaning, use neutral detergent to test, do not use soap, laundry detergent or other strong acid, strong alkali chemicals.'
                   ],
                
                   remarker:'注:如在空运过程中造成箱包损坏,可直接向航空公司索赔。',
                   remarkeren:'Note: If the bag is damaged during air transportation, you can claim directly from the airline.',
                },

                tenttfoursc:{
                    titleone:'箱包乘机标准',
                    titleoneen:'Bags and bags boarding standards.',
                   content:[
                    '登机箱常用标准(经济仓)。',
                    '重量:7公斤以下。',
                    '尺寸:三边之和115CM以下(长53CM*宽40CM*厚22CM)。',
                    '谱祺登机箱尺寸:20“以下(含20”)(1英寸等于2.54CM)。',
                    '机内行李仓尺寸:长200CM*宽48CM*厚28CM(波音737/7571747，空客319/320/321等大中型飞机)。',
                   ],
                   contenten:[
                    'The common standard of carry-on suitcases (economy class).',
                    'Weight: up to 7 kg.',
                    'SIZE: THE SUM OF THE THREE SIDES IS 115CM OR LESS (LENGTH 53CM * WIDTH 40CM * THICKNESS 22CM).',
                    'Size of Spectrum Carry-on Suitcase: 20" or less (including 20") (1 inch is equal to 2.54CM).',
                    'SIZE OF THE BAGGAGE COMPARTMENT IN THE AIRCRAFT: LENGTH 200CM * WIDTH 48CM * THICKNESS 28CM (Boeing 737/7571747, Airbus 319/320/321 AND OTHER LARGE AND MEDIUM-SIZED AIRCRAFT).',
                   ],

                   contenttwo:[
                    '托运箱常用标准(经济仓)。',
                    '重量:20公斤以下。',
                    '尺寸:长/宽/厚三边之和在158CM之下。',
                    '托运箱尺寸:30”左右',
                   ],
                   contenttwoen:[
                    'Common standard for consignment boxes (economy warehouse).',
                    'Weight: up to 20 kg.',
                    'Size: The sum of the three sides of length/width/thickness is less than 158CM.',
                    'Consignment box size: about 30".',
                   ],
                
                   remarker:'注:具体细则请咨询对应航司的登机托运规则。',
                   remarkeren:'Note: For specific details, please consult the boarding and check-in rules of the corresponding airline.',
                },
                 
              
               

                imageUrlone: require('../../assets/kehufuwus15-15.png'),
                imageUrltwo: require('../../assets/logotuteng.png'),
                isScrolled: false,
        
            };
        },

        mounted() {
            // this.fetchData();
            this.initObserver(); // 初始化观察器
             window.addEventListener('wheel', this.initObserver, { passive: false });
          // 添加滚动监听到 .boddy 容器上
    this.$refs.boddy.addEventListener('scroll', this.handleScroll2);

        },
        beforeDestroy() {

              // 组件销毁时移除监听
    this.$refs.boddy.removeEventListener('scroll', this.handleScroll2);

            window.removeEventListener('wheel', this.initObserver);
            this.$refs.boddy.removeEventListener('scroll', this.debouncedHandleScroll);
            window.removeEventListener('wheel', this.handleScroll);
        },
        methods: {

            handleScroll2() {
                    // 使用容器的 scrollTop 获取滚动距离
        const scrollTop = this.$refs.boddy.scrollTop;
        // 当滚动超过200px时显示二维码
        this.showQrCode = scrollTop>600;
        console.log(this.showQrCode)
                },



            async fetchData() {
            try {
                // 发起 API 请求
                const response = await axios.get(`${apiUrls.baseUrl}/website/api/aftersales`);
                const data = response.data;
                console.log(data)
                if (data && data.length > 0) {
                    // 处理 banner 图片
                    this.imageUrlone = `${apiUrls.devApi}${data[0].imageUrlone}`;
                    // 分批赋值
                    this.throttledAssignData(data);
                 
                   
                }
            } catch (error) {
                console.error('获取数据失败:', error);
            }
        }, 
        /**
         * 
         * @param html 文本提取
         */
        stripHTMLTags(html) {
        // 创建一个 DOMParser 实例
        const parser = new DOMParser();
        // 将 HTML 字符串解析成文档对象
        const doc = parser.parseFromString(html, 'text/html');
        // 获取文档体的纯文本内容
        return doc.body.textContent || '';
    },
    /**
     * 
     * @param html li文本提取
     */
    stripHTMLTags2(html) {
        // 创建一个 DOMParser 实例
        const parser = new DOMParser();
        // 将 HTML 字符串解析成文档对象
        const doc = parser.parseFromString(html, 'text/html');
        // 提取所有 <li> 元素的文本内容，并存入数组
            return Array.from(doc.querySelectorAll('li')).map(item => item.textContent.trim());
    },
            /**
             * 
             * @param html 重要说明的数据提取
             */
            extractTextByTag(html) {
            // 创建一个 DOMParser 实例
            const parser = new DOMParser();
            // 将 HTML 字符串解析为文档对象
            const doc = parser.parseFromString(html, 'text/html');
            
            // 定义一个对象，用于按标签类型存储文本
            const groupedText = {};

            // 遍历文档中的所有子元素
            Array.from(doc.body.children).forEach(node => {
                const tagName = node.tagName.toLowerCase(); // 获取标签名
                const textContent = node.textContent.trim(); // 获取纯文本并去除空白

                if (textContent) {
                    // 如果对应标签的数组不存在，则初始化
                    if (!groupedText[tagName]) {
                        groupedText[tagName] = [];
                    }
                    // 将文本加入对应标签的数组
                    groupedText[tagName].push(textContent);
                }
            });

            return groupedText;
        },
         throttledAssignData(data) {
            // 定义赋值的节奏
            const steps = [
                () => {
                    this.tenttwo.imageUrltwo = `${apiUrls.devApi}${data[0].imageUrltwo}`;
                    this.tenttwo.texttwo=data[0].tenttwotexttwo;
                    this.tenttwo.texttwoen=data[0].tenttwotexttwoen;
                   
                  
                  this.tenttfour.titleone=data[0].tenttfourtitleone;
                  this.tenttfour.titleoneen=data[0].tenttfourtitleoneen;
                  // 提取 tenttfourcontent 中的纯文本内容
                    this.tenttfour.content = this.stripHTMLTags2(data[0].tenttfourcontent);
                     // 提取 tenttfourcontent 中的纯文本内容
                     this.tenttfour.contenten = this.stripHTMLTags2(data[0].tenttfourcontenten);
                     this.tenttfour.remarker = data[0].remarker;
                     this.tenttfour.remarkeren = data[0].remarkeren;


                },
                () => {
                   
                  
                                    // 将返回的路径字符串分割为数组
                const imagePaths = data[0].servicesimgSrc.split(','); // 将路径字符串分割为数组
                const servicestitle= data[0].servicestitle.split(';'); // 将路径字符串分割为数组
                const servicestitleen= data[0].servicestitleen.split(';'); // 将路径字符串分割为数组
                const description=this.stripHTMLTags(data[0].servicesdescription).match(/[^。]+。/g) || [];
                const descriptionen=this.stripHTMLTags(data[0].servicesdescriptionen).match(/[^。]+。/g) || [];
                
                
                  
                },
                () => {
                    
                    // console.log(this.zhoangyaoshuoming.items)
                },
                () => {
                    
                     // 提取所有问题
                    let match;
                    while (match = questionPattern.exec(content2)) {
                        questions.push(match[1].trim());  // 将问题内容去掉多余的空格，保存到数组
                    }

                  
                    


                 
                }
            ];

            let stepIndex = 0;

            const assignNextStep = () => {
                if (stepIndex < steps.length) {
                    steps[stepIndex](); // 执行当前赋值步骤
                    stepIndex++;

                    // 使用 setTimeout 控制下一次赋值节奏
                    setTimeout(assignNextStep, 100); // 每次间隔 100ms
                } else {
                    console.log('所有数据赋值完成');
                }
            };

            assignNextStep(); // 开始逐步赋值
        },
            initObserver() {
                // console.log(this.isEnglish)
                const options = {
                    root: this.$refs.boddy,
                    rootMargin: '0px',
                    threshold: 0.1 // 10% 进入视口时触发
                };
                const ss=   options.root.scrollTop;
                if(ss!=0){
                    this.isScrolled = true;
                }else{ this.isScrolled=false;}


            },


            handleScroll(event) {
                if (event.deltaY !== 0) {
                    const isMobile = window.innerWidth < 768;
                    if (isMobile) {
                        return; // 如果是手机界面，直接返回，取消滚动效果
                    }
                    const scrollContainer = this.$refs.boddy;
                    if (scrollContainer.scrollTop === 0) {
                        this.scrollCount = 0;
                    }
                     // 获取每个section元素
                     const sectionElements = this.$refs.sectionElement;
                     // 计算当前应该滚动到哪个section
                     const direction = event.deltaY > 0 ? 1 : -1; // 根据滚动方向确定是向上还是向下
                     // 计算滚动后的位置
                    this.scrollCount += direction;
                    // 防止越界
                    if (this.scrollCount < 0) this.scrollCount = 0;
                    if (this.scrollCount >= sectionElements.length) this.scrollCount = sectionElements.length - 1;

                    // 使用 scrollIntoView 确保滚动到该 section
                    const targetSection = sectionElements[this.scrollCount];
                    if (targetSection) {
                    targetSection.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center', // 使目标元素在视口的垂直方向居中
                        inline: 'center' // 水平方向居中（可选）
                    });
                    }




                    const scrollHeight = scrollContainer.scrollHeight;
                    const containerHeight = scrollContainer.clientHeight;
                    // 检查滚动位置并设置 isScrolled
                    // 滚动状态判断
                    const scrollTop = scrollContainer.scrollTop;
                    if (scrollTop === 0) {
                        this.isScrolled = false;
                    } else if (scrollTop + containerHeight >= scrollHeight) {
                        this.isScrolled = true;
                    } else {
                        this.isScrolled = true;
                    }
                    let height;
                        height = window.innerHeight;
                        
                        scrollContainer.scrollBy({

                            top: event.deltaY > 0 ? height : -height,
                            behavior: 'smooth'
                        });


                    this.scrollCount += 1; // 增加滚动计数
                    // 等待 DOM 更新后再检查可见的 sections
                  

                        // 重新添加 fadeIn 类到当前可见的 .content
                        //this.checkVisibleSections(); // 检查可见的 sections

                       




                    event.preventDefault();
                }
            },
            debounce(func, wait) {
                let timeout;
                return function(...args) {
                    const context = this;
                    clearTimeout(timeout);
                    timeout = setTimeout(() => func.apply(context, args), wait);
                };
            },
        }
    }
</script>
<style scoped>
/*? -------------------------------------------*/
 /* 按钮样式 */
 .submit-btn {
    width: 6vw;
    padding: 1.5vh;
    background-color: #333;
    color: white;
    font-size: 0.8rem;
    font-weight: bold;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    transition: background-color 0.3s;
    margin-left: 12.2vw;
    
}
.submit-btn:hover {
    background-color: #555;
}

.fomeillustrate{
display: flex;
flex-direction: column;      /* 子元素垂直排列 */
justify-content: center;     /* 垂直方向居中 */
align-items: center;         /* 水平方向居中 */
margin-top: -3vh;
/* height: 40vh; */
margin-bottom: 8vh;

}
.fomeillustrate .title{
width: 60vw;
font-weight: bold;
font-size: 1.5rem;
margin-bottom: 5vh;
}

/* 表单容器样式 */
.form-container {
    display: flex;
    justify-content: center;
    align-items: center;
    /* min-height: 100vh; */
    background-color: white;

}

.form-container .custom-form{
  width: 60vw;
  /* background-color: white; */
  border-radius: 5px;
  /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); */
}
.form-container .custom-form .form-group {
    margin-bottom: 6vh;
    display: flex;
    align-items: center;
    gap: 3vw;
    
}
.form-container .custom-form .form-group label {
    width: 9vw; /* 标签宽度，保持对齐 */
    font-size: 1rem;
    color: #333;
    text-align: left;
    
}
.form-container .custom-form .form-group input, textarea {
    flex: 1;
    padding: 1vw;
    border: 1px solid #ddd;
    /* border-radius: 3px; */
    background-color: #f5f5f5;
    font-size: 14px;
    color: #333;
    outline: none;
    transition: border-color 0.3s;

}

textarea {
    resize: none; /* 禁止调整大小 */
    height: 10vh;
}


.illustrate{
display: flex;
flex-direction: column;      /* 子元素垂直排列 */
justify-content: center;     /* 垂直方向居中 */
align-items: center;         /* 水平方向居中 */
margin-top: 5vh;
height: 45vh;

}
.illustrate .title{
width: 60vw;
font-weight: bold;
font-size: 1.5rem;
margin-bottom: 3vh;


}
.illustrate .contentphone{
width: 60vw;

font-size:1rem;
line-height: 2;
color: gray;
white-space: pre;
}
.illustrate .contentemail{
width: 60vw;
font-size:1rem;
line-height: 2;
color: gray;
white-space: pre;

}
/*? -------------------------------------------*/








/* 台式大电脑 (1200px 及以上) 样式 */
@media (min-width: 1600px) {
    .xiahuaxian{
        margin-top: 54vh!important;
    }
}
/* 第一张图片开始 */
.imgone img{
    width: 100%;
        height: auto;
        /* margin-bottom: 9vh; */
}
.imgoneru{
    width: 100%;
        height: auto;
        /* margin-bottom: 9vh; */
}
/* 第一张图片结束 */
    .fadeIn {
        animation: fade-in ease 2s !important; /* 添加 !important 提高优先级 */
        animation-fill-mode: forwards;
    }
    @keyframes fade-in {
        from {
            opacity: 0;
            transform: translateY(100px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .red{
        background-color: red;
    }
/*整体布局开始*/
.boddy {
height: 100vh;
background-color: white;


overflow-y: auto; /* 允许垂直滑动 */
}
/* 隐藏滚动条，适用于Webkit浏览器（如Chrome、Safari） */
.boddy::-webkit-scrollbar {
display: none;
}

/* 隐藏滚动条，适用于Firefox */
.boddy {
scrollbar-width: none; /* Firefox */
}

/* 隐藏滚动条，适用于Internet Explorer 和 Edge */
.boddy {
-ms-overflow-style: none; /* Internet Explorer 和 Edge */
}

/*整体布局结束*/
/*内容部分开始*/
.section{
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
}
/*内容部分结束*/
.titlehed{
    display: none;

}
/*手机端样式开始*/
@media screen and (max-width: 768px) {

    .titlehed{
        display: block!important;
        height: 10rem!important;
    }

}
/*手机端样式结束*/



.maintenance-section {
    padding: 20px;

    display: flex;
    flex-direction: column;
    align-items: flex-start; /* 修改这里 */
    justify-content: center;
    padding-left: 20vw;
}
.section-title {
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 12px;
    color: #333;
}
.section-content {
    color: black;
    line-height: 2;
    
    width: 60vw;
    font-size: 1rem;
}
/* 添加分隔线样式 */
.divider {
    height: 0.5px;
    background-color: gray;
    margin: 20px 0;
    width: 60vw;
    margin-top: 7vh;
}
/* 去掉最后一个分隔线 */
.maintenance-section:last-child .divider {
    display: none;
}



/* 添加固定二维码样式 */
.qr-code {
    position: fixed;
    left: 90vw;
    top: 50%;
    transform: translateY(50%);
    width: 100px;
    height: 150px;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    border-radius: 8px;
    padding: 8px;
    z-index: 999;

     /* 添加过渡效果 */
     opacity: 0;
    
     transition: all 0.3s ease;

     display: flex;
     flex-direction: column;
     align-items: center;
     justify-content: center;
     gap: 0.1rem;
     line-height: 0;
}
/* 显示二维码的样式 */
.qr-code.show {
    opacity: 1!important;
    
}

.qr-code img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
</style>
